import { type Desil, useGetPublicDesilFiltered } from '@tatatemplate/shared-lib'

/**
 * Desil terfilter, PLUS totalnya.
 *
 * Total dihitung di klien dan itu koreksi, bukan tambahan: backend Hono dulu memulangkan
 * `{ data, totals }`, gobackend memulangkan `{ data }` saja dan kontraknya menyatakan
 * demikian. Komponen yang membaca `.data.totals` karena itu sudah membaca `undefined`
 * sejak backend berpindah.
 */
export function useDesilFiltered(filters?: {
  tahap?: number
  startYear?: number
  endYear?: number
  sortOrder?: 'asc' | 'desc'
}) {
  return useGetPublicDesilFiltered(filters, {
    query: {
      queryKey: ['desil', 'filtered', filters],
      select: (res) => ({ data: { data: res.data, totals: hitungTotal(res.data) } }),
      staleTime: 5 * 60 * 1000,
      retry: 3,
    },
  })
}

function hitungTotal(rows: Desil[]) {
  const jumlah = (ambil: (row: Desil) => number) => rows.reduce((acc, row) => acc + ambil(row), 0)
  return {
    jumlahKpm: jumlah((r) => r.jumlahKpm),
    desil1: jumlah((r) => r.desil1),
    desil2: jumlah((r) => r.desil2),
    desil3: jumlah((r) => r.desil3),
    desil4: jumlah((r) => r.desil4),
    desil5: jumlah((r) => r.desil5),
    desil6_10: jumlah((r) => r.desil6_10),
    belumDiperingkat: jumlah((r) => r.belumDiperingkat),
    total: jumlah((r) => r.total),
  }
}
